import {
  Box,
  Table,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";

import TicketsPerAgentLineGraph from "../../charts/daily/TicketsPerAgentLineGraph";
import { formatNumber, formatPercent } from "../../../../store/helpers";

const AgentTables = ({
  data,
  totalBranchTickets,
  branchName,
  
  branchIndex,
}) => {
  return (
    <>
      {data.map((agentData, index) => {
        const {
          min,
          max,
          total,
          average,
          numCompleted,
          numNoShow,
          numUnattended,
          pctCompleted,
          pctNoShow,
          pctUnattended,
          agentName,
          chart,
        } = agentData;

        let totalPct = (total / totalBranchTickets) * 100 || 0;
        const title = `${branchIndex + 1}.${
          index + 1
        }. ${agentName}`;
        
        return (
            <Box key={index} className="reportContainer" mt="20px">
              <h3>{title}</h3>
              <Tag.Root>
                <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
              </Tag.Root>
              {total ? (
                <>
                  {" "}
                  <Table.Root className="stripedTable" size="sm">
                    <Table.Header>
                      <Table.Row>
                        <Table.ColumnHeader>#</Table.ColumnHeader>
                        <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                        <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
                        <Table.ColumnHeader>Min</Table.ColumnHeader>
                        <Table.ColumnHeader>Max</Table.ColumnHeader>
                        <Table.ColumnHeader>Completed</Table.ColumnHeader>
                        <Table.ColumnHeader>No Show</Table.ColumnHeader>
                        <Table.ColumnHeader>Unattended</Table.ColumnHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>{index + 1}</Table.Cell>
                        <Table.Cell borderRight="1px solid #dadce0">
                          <VStack gap="2px" align="start">
                            <Text color={"var(--green)"}>
                              {formatNumber(total)}
                            </Text>
                            <Text
                              color="gray.500"
                              fontWeight="semibold"
                              fontSize="xs"
                              textTransform="uppercase"
                            >
                              ({formatPercent(totalPct)})
                            </Text>
                          </VStack>
                        </Table.Cell>
                        <Table.Cell borderRight="1px solid #dadce0">
                          {formatNumber(average)}
                        </Table.Cell>
                        <Table.Cell>{formatNumber(min)}</Table.Cell>
                        <Table.Cell>{formatNumber(max)}</Table.Cell>
                        <Table.Cell>
                          <VStack gap="2px" align="start">
                            <Text color={"var(--green)"}>
                              {formatNumber(numCompleted)}
                            </Text>
                            <Text
                              color="gray.500"
                              fontWeight="semibold"
                              fontSize="xs"
                              textTransform="uppercase"
                            >
                              ({formatPercent(pctCompleted)})
                            </Text>
                          </VStack>
                        </Table.Cell>

                        <Table.Cell>
                          <VStack gap="2px" align="start">
                            <Text color={"var(--red)"}>
                              {formatNumber(numNoShow)}
                            </Text>
                            <Text
                              color="gray.500"
                              fontWeight="semibold"
                              fontSize="xs"
                              textTransform="uppercase"
                            >
                              ({formatPercent(pctNoShow)})
                            </Text>
                          </VStack>
                        </Table.Cell>

                        <Table.Cell>
                          <VStack gap="2px" align="start">
                            <Text color={"var(--red)"}>
                              {formatNumber(numUnattended)}
                            </Text>
                            <Text
                              color="gray.500"
                              fontWeight="semibold"
                              fontSize="xs"
                              textTransform="uppercase"
                            >
                              ({formatPercent(pctUnattended)})
                            </Text>
                          </VStack>
                        </Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell colSpan={8}>
                          <Box mt="20px" mb="20px">
                            <TicketsPerAgentLineGraph
                              chart={chart}
                              data={data}
                              title={`${agentName} Tickets, Hour by Hour Comparison`}
                            />
                          </Box>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table.Root>
                </>
              ) : (
                <>
                  {" "}
                  <Text fontSize="sm">No data available for this report</Text>
                </>
              )}
            </Box>
        );
      })}
    </>
  );
};

const TicketsPerAgentTable = ({ data, branchId, branchIndex }) => {
  const { agentsData, branchName } = data;
  const totalBranchTickets = agentsData
    .map((a) => a.total)
    .reduce((acc, val) => {
      acc += val;
      return acc;
    }, 0);

  return (
    <Box>
      <Text>{agentsData.length} agents.</Text>
      {!agentsData.length && (
        <Text fontSize="sm">No data available for this report</Text>
      )}

      {agentsData.length && (
        <>
          <AgentTables
            totalBranchTickets={totalBranchTickets}
            
            branchIndex={branchIndex}
            data={agentsData}
            branchName={branchName}
          />
        </>
      )}
    </Box>
  );
};

export default TicketsPerAgentTable;
